import React, { Component } from 'react'
import classes from './Header.module.css'
import logoFull from '../../images/icon/logoExchFull.svg'
import logo from '../../images/icon/logoExch.svg'
import menu from '../../images/menu.svg'
import close from '../../images/close.svg'
import { withTranslation } from 'react-i18next'
import i18n, { strings } from '../../i18n'
import { analytics } from 'firebase'

class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            crypto: false,
            height: 512
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    container = React.createRef()

    handleButtonClick = async () => {
        this.setState({
            open: !this.state.open
        })
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions.bind(this))
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
        window.removeEventListener('resize', this.updateWindowDimensions.bind(this))
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight })
    }

    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({
                open: false,
            })
        }
    }

    render() {
        return (
            <header className={classes.main}>
                <nav className={classes.navbar}>
                    <div className={classes.left_header}>
                        <a href={'https://trustee.deals'} target="_blank" rel={'noopener noreferrer'} onClick={() => {
                            analytics().logEvent('click_logo')
                        }}>
                            <div className={classes.logo}>
                                <img src={logoFull} alt={'logo'} />
                            </div>
                            <div className={classes.logo__mobile}>
                                <img src={logo} alt={'logo'} />
                            </div>
                        </a>
                    </div>
                    <div className={classes.right_header}>
                        <div className={classes.item} id={classes.item}>
                            <a href={'https://blog.trustee.deals/ru/blog/'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_blog')
                                }}>
                                {strings('header.blog')}
                            </a>
                        </div>
                        <div className={classes.item} id={classes.item}>
                            <a href={'https://trustee.deals/faq'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_faq')
                                }}>
                                {strings('header.faq')}
                            </a>
                        </div>
                        <div className={classes.dropdown_menu} ref={this.container}>
                            <button type={'button'} onClick={this.handleButtonClick}>
                                <div className={classes.item}>
                                    <img src={this.state.open ? close : menu} alt={'menu'} />
                                </div>
                            </button>
                            {this.state.open && (
                                <div className={classes.dropdown_menu_child}>
                                    <div className={classes.list_func}>
                                        <div className={classes.list__item}>
                                            <a href={'https://trustee.deals/buy-bitcoin'} target="_blank"
                                                rel={'noopener noreferrer'} onClick={() => {
                                                    analytics().logEvent('click_buy_bitcoin')
                                                }}>
                                                {strings('header.buyBitcoin')}
                                            </a>
                                        </div>
                                        <div className={classes.list__item}>
                                            <a href={'https://trustee.deals/buy-ethereum'} target="_blank"
                                                rel={'noopener noreferrer'} onClick={() => {
                                                    analytics().logEvent('click_buy_ethereum')
                                                }}>
                                                {strings('header.buyEthereum')}
                                            </a>
                                        </div>
                                        <div className={classes.list__item}>
                                            <a href={'https://trustee.deals/bitcoin-crypto-price-marketcap'}
                                                target="_blank"
                                                rel={'noopener noreferrer'}>
                                                {strings('header.cryptoExchangeRates')}
                                            </a>
                                        </div>
                                    </div>
                                    <div className={classes.list__mobile}>
                                        <div
                                            className={!this.state.crypto ? classes.list__mobile__item : classes.list__mob}>
                                            <div onClick={() => this.setState({
                                                ...this.state,
                                                crypto: !this.state.crypto
                                            })}>
                                                {strings('header.buyCrypto')}
                                            </div>
                                        </div>
                                        {this.state.crypto ?
                                            <div className={classes.list__add}>
                                                <div className={classes.list__item}>
                                                    <a href={'https://trustee.deals/buy-bitcoin'} target="_blank"
                                                        rel={'noopener noreferrer'} onClick={() => {
                                                            analytics().logEvent('click_buy_bitcoin')
                                                        }}>
                                                        {strings('header.buyBitcoin')}
                                                    </a>
                                                </div>
                                                <div className={classes.list__item}>
                                                    <a href={'https://trustee.deals/buy-ethereum'} target="_blank"
                                                        rel={'noopener noreferrer'} onClick={() => {
                                                            analytics().logEvent('click_buy_ethereum')
                                                        }}>
                                                        {strings('header.buyEthereum')}
                                                    </a>
                                                </div>
                                            </div> : null}
                                        <div className={classes.list__item}>
                                            <a href={'https://t.me/trustee_support_bot'} target="_blank"
                                                rel={'noopener noreferrer'} onClick={() => {
                                                    analytics().logEvent('click_support')
                                                }}>
                                                {strings('header.support')}
                                            </a>
                                        </div>
                                        <div className={classes.list__item}>
                                            <a href={'https://blog.trustee.deals/ru/blog/'} target="_blank"
                                                rel={'noopener noreferrer'} onClick={() => {
                                                    analytics().logEvent('click_blog')
                                                }}>
                                                {strings('header.blog')}
                                            </a>
                                        </div>
                                        <div className={classes.list__item}>
                                            <a href={'https://trustee.deals/faq'} target="_blank"
                                                rel={'noopener noreferrer'} onClick={() => {
                                                    analytics().logEvent('click_faq')
                                                }}>
                                                {strings('header.faq').toLocaleUpperCase()}
                                            </a>
                                        </div>
                                        <div className={classes.list__item}>
                                            <a href={'mailto:contact@trustee.deals'} target="_blank"
                                                rel={'noopener noreferrer'} onClick={() => {
                                                    analytics().logEvent('click_contact_us')
                                                }}>
                                                {strings('header.contactUs')}
                                            </a>
                                        </div>
                                    </div>
                                    <div className={classes.locate}>
                                        <div className={classes.locate__item}>
                                            <div onClick={() => {
                                                i18n.changeLanguage('uk')
                                                localStorage.setItem('locale', 'uk')
                                                this.setState({
                                                    open: false,
                                                })
                                                analytics().logEvent('click_uk')
                                            }}>
                                                UK
                                            </div>
                                        </div>
                                        <div className={classes.locate__item}>
                                            <div onClick={() => {
                                                i18n.changeLanguage('ru')
                                                localStorage.setItem('locale', 'ru')
                                                this.setState({
                                                    open: false,
                                                })
                                                analytics().logEvent('click_ru')
                                            }}>
                                                RU
                                            </div>
                                        </div>
                                        <div className={classes.locate__item}>
                                            <div onClick={() => {
                                                i18n.changeLanguage('en')
                                                localStorage.setItem('locale', 'en')
                                                this.setState({
                                                    open: false,
                                                })
                                                analytics().logEvent('click_en')
                                            }}>
                                                EN
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>
            </header>
        )
    }
}

export default withTranslation()(Header)